export const SLA_TARGETS = {
  critical: { responseMinutes: 30, resolutionHours: 4 },
  high: { responseMinutes: 60, resolutionHours: 24 },
  medium: { responseMinutes: 120, resolutionHours: 48 },
  low: { responseMinutes: 240, resolutionHours: 72 },
} as const;

// Labour rates — re-export from the canonical source in src/utils/labourRates.ts.
// Default values match Techery's AU rates (cost $120/hr, sell $240/hr); per-tenant
// overrides live at `tenant.business.labourRates.{faultPerHour, sellPerHour}` and
// are merged in by `getFaultLabourRatePerHour(tenant)` /
// `getLabourSellRatePerHour(tenant)`. These re-exports preserve the existing
// import shape so callers without tenant context still see the defaults.
//
// LABOUR_RATE_PER_HOUR — internal cost rate. Used for fault cost rollups +
// project cost-side math (CableSchedule / useProjectCableRuns).
// LABOUR_SELL_RATE_PER_HOUR — client-facing sell rate (roughly 2× cost today).
// Referenced in master plan §4.7 formulas as LABOUR_SELL_RATE.
//
// TODO(saas-readiness): callers should switch to `getFaultLabourRatePerHour(tenant)`
// / `getLabourSellRatePerHour(tenant)` so per-tenant overrides take effect.
// Tracked as a follow-up to the SaaS-readiness audit (May 2026).
export { DEFAULT_FAULT_LABOUR_RATE_PER_HOUR as LABOUR_RATE_PER_HOUR } from '@/utils/labourRates';
export { DEFAULT_LABOUR_SELL_RATE_PER_HOUR as LABOUR_SELL_RATE_PER_HOUR } from '@/utils/labourRates';
